<!-- Angular Three Canvas -->
<!-- Always render canvas, even with null config - scene component can handle empty state -->
<ngt-canvas
  [sceneGraph]="sceneComponent()"
  [camera]="cameraConfig()"
  [shadows]="true"
  (created)="onCanvasCreated($event)"
  class="game-canvas scene-element">
</ngt-canvas>

<!-- Optional CTA Button -->
@if (showCTA() && ctaButton?.enabled) {
  <button
    mat-raised-button
    (click)="triggerGameplay()"
    [disabled]="ctaDisabled()"
    class="cta-button"
    [style.background-color]="ctaButton?.backgroundColor || '#6200ea'"
    [style.color]="ctaButton?.textColor || '#ffffff'"
    [style.bottom]="ctaButton?.position?.bottom || '80px'">
    {{ ctaLabel() || ctaButton?.text || 'Play' }}
  </button>
}
